import { createAction, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const ADJUST_PAYMENT_ANALYTICS_ACTIONS = {
  trackPageLoad: createAction(
    '[NgRxClient Analytics] - Track Adjust Payment Page Load',
    props<{
      tracking: Tracking;
    }>(),
  ),

  trackOpeningShortPayModal: createAction(
    '[NgRxClient Analytics] - Track Opening Short Payment Modal',
    props<{
      tracking: Tracking;
    }>(),
  ),

  trackSubmittingShortPayModal: createAction(
    '[NgRxClient Analytics] - Track Submitting Short Payment Modal',
    props<{
      tracking: Tracking;
    }>(),
  ),

  trackClosureShortPayModal: createAction(
    '[NgRxClient Analytics] - Track Closure Short Payment Modal',
    props<{
      tracking: Tracking;
    }>(),
  ),
};
